import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchCmsMetaData } from "../../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";
import DeactivateAccount from "./MyprofileModal/DeactivateAccount";

function UserSetting() {
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [meta,setMeta] = useState();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); // ya "auto"
  }, []);

   useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("setting");
      setMeta(data);
    };

    loadMeta();
  }, []);
  return (
    <>
      <section className="mng_bottomss user_allls settingssss">
        <SetMetaTags
        title= {meta?.meta_title || "Setting | Weyfarin"}
        description={meta?.meta_description || "Setting | Weyfarin"}
      
      />

        <div className="bedcramss">
          <Link to="/profile">Dashboard</Link> &gt; Setting
        </div>
        <div className="prfo_listst lastsst al_sec_ctxt pt-4 settingss">
          <h4>Setting </h4>

          <div className="form_al_fildss">
            <form action="">
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <label className="act_txx">Account </label>
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-group managess">
                    <label>Deactivate your account </label>{" "}
                    <span
                      className="cliccss"
                      onClick={() => setShowDeactivateModal(true)}
                      style={{ cursor: "pointer" }}
                    >
                      Deactivate
                    </span>
                    <p>This action cannot be undone</p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>

      <DeactivateAccount
        isOpen={showDeactivateModal}
        onClose={() => setShowDeactivateModal(false)}
        onSave={() => {
          
          setShowDeactivateModal(false);
        }}
      />
    </>
  );
}

export default UserSetting;
